import { Product, Location } from '@/types';
import axios from 'axios';
import { DateTime } from 'luxon';
import { defineStore } from 'pinia';

type GeneralStoreState = {
  products: Product[];
  isTablet: boolean;
  isMobile: boolean;
  submittedData: {
    visitType: string;
    time: DateTime;
    comment: string;
    location: string;
    doctor: string;
  } | null;
  workingHours: Record<string, { start: number; end: number }>;
  locations: Record<string, Location>;
};

let productsPromise: Promise<Product[]> | null = null;
let workingHoursRequest: Promise<Record<string, { start: number; end: number }>> | null = null;

export const generalStore = defineStore('generalStore', {
  state: (): GeneralStoreState => ({
    products: [],
    isTablet: false,
    isMobile: false,
    workingHours: {},
    submittedData: null,
    locations: {
      'Ljubljana': {
        location: 'Ljubljana',
        address: 'Na jami 14, 1000 Ljubljana',
        mapLink: 'https://maps.app.goo.gl/TnyeLbuXJovGDGzL6',
        email: 'info@nordic-dental.si',
        phone: '01 777 41 65',
        workingHours: {
          1: {
            start: 900,
            end: 1600,
          },
          2: {
            start: 900,
            end: 1600,
          },
          3: {
            start: 900,
            end: 1600,
          },
          4: {
            start: 900,
            end: 1600,
          },
          5: {
            start: 900,
            end: 1600,
          },
        },
        map: {
          center: { lat: 46.0668316, lng: 14.4860782 },
          markerPosition: { lat: 46.0668316, lng: 14.4897159 },
        },
      },
      'Vodice': {
        location: 'Vodice',
        address: 'Kopitarjev trg 1, 1217 Vodice',
        mapLink: 'https://maps.app.goo.gl/u5G23RqsfHufE8YD6',
        email: 'info@nordic-dental.si',
        phone: '01 777 41 04',
        workingHours: {
          1: {
            start: 1030,
            end: 1930,
          },
          2: {
            start: 1030,
            end: 1900,
          },
          3: {
            start: 730,
            end: 1300,
          },
          4: {
            start: 730,
            end: 1230,
          },
          5: {
            start: 730,
            end: 1200,
          },
        },
        map: {
          center: { lat: 46.1871757, lng: 14.4874154 },
          markerPosition: { lat: 46.1871757, lng: 14.4910531 },
        },
      },
    },
  }),
  actions: {
    formatPrice(price: number) {
      const toEuros = new Intl.NumberFormat('sl-SI', {
        style: 'currency',
        currency: 'EUR',
      });

      return toEuros.format(price / 100);
    },
    fetchProducts() {
      if (!productsPromise) {
        productsPromise = axios.get<Product[]>('/api/products').then((response) => {
          this.products = response.data;
          return response.data;
        });
      }

      return productsPromise;
    },

    fetchWorkingHours() {
      if (!workingHoursRequest) {
        workingHoursRequest = axios.get('/api/workhours').then((response) => {
          this.workingHours = response.data;
          return response.data;
        });
      }
      return workingHoursRequest;
    },
  },
});
